import React from 'react';

export default function MultiCheckPanel(props) {
    var locale = props.locale || 'vi';
    var options = (props.config && props.config.options) || [];
    var codes = (props.value && props.value.codes) || [];

    function toggle(code) {
        var next = codes.indexOf(code) >= 0
            ? codes.filter(function (c) { return c !== code; })
            : codes.concat([code]);
        props.onChange({ codes: next });
    }

    return (
        <div className="wiz-multi">
            {options.map(function (opt) {
                var on = codes.indexOf(opt.code) >= 0;
                var label = (opt.label && (opt.label[locale] || opt.label.en || opt.label.vi)) || opt.code;
                return (
                    <label
                        key={opt.code}
                        className={'wiz-multi__opt' + (on ? ' wiz-multi__opt--on' : '')}
                    >
                        <input
                            type="checkbox"
                            checked={on}
                            onChange={function () { toggle(opt.code); }}
                        />
                        <span className="wiz-multi__label">{label}</span>
                    </label>
                );
            })}
        </div>
    );
}
